<aside class="control-sidebar control-sidebar-dark"><!--right-sidebar-open-->
    <div class="os-content">
         <h5>Customize VioAdminLTE</h5>
         <hr class="mb-2">

          <div class="message">
            <div class="list-group list-group-accent test">
    
              <div class="list-group-item list-group-item-accent-secondary text-left font-weight-bold text-muted text-uppercase small">
                    <span>Layout Setting</span>
                    <!-- <label class="switch switch-primary">
                        <input type="checkbox" class="switch-input" checked>
                        <span class="switch-slider"></span>
                    </label> -->
                    <label class="switch-toggle">
                        <input id="layoutsetting" type="checkbox">
                        <span class="slider"></span>
                    </label>
              </div>
    
              <div class="list-group-item list-group-item-accent-secondary list-group-item-divider layout-setting">
                  <div class="radio-check">
                  <div class="radio-toolbar">
                      <input type="radio" id="radio1" name="radios" value="all" checked>
                      <label for="radio1" >
                          <div class="head"></div>
                          <div class="sidepan"></div>
                      </label>
                    
                      <input type="radio" id="radio2" name="radios" value="false">
                      <label for="radio2" >
                          <div class="head"></div>
                          <div class="sidepan"></div>
                      </label>
    
                      <input type="radio" id="radio3" name="radios" value="true">
                      <label for="radio3" >
                        <div class="head"></div>
                        <div class="sidepan"></div>
                      </label>
    
                  </div>
                  </div>
              </div>

              <div class="list-group-item list-group-item-accent-secondary text-left font-weight-bold text-muted text-uppercase small">
                <span>HEADER COLOR</span>
                <!-- <div class="form-check" style="float: right;">
                    <input class="form-check-input" id="flexCheckDefault" type="checkbox">
                </div> -->
                <label class="switch-toggle">
                    <input id="headercolorsetting" type="checkbox">
                    <span class="slider"></span>
                </label>
              </div>

              <div class="list-group-item list-group-item-accent-secondary list-group-item-divider header-bar">
                        <div class="radio-check">
                            <div class="radio-toolbar">
                                <input type="radio" id="radio1" name="radios" value="all" checked>
                                <label for="radio1"></label>
                                
                                <input type="radio" id="radio2" name="radios" value="false">
                                <label for="radio2"></label>
                                
                                <input type="radio" id="radio3" name="radios" value="true">
                                <label for="radio3"></label>
                
                                <input type="radio" id="radio4" name="radios" value="true">
                                <label for="radio4"></label>
                
                                <input type="radio" id="radio5" name="radios" value="true">
                                <label for="radio5"></label>
                
                                <input type="radio" id="radio6" name="radios" value="true">
                                <label for="radio6"></label>
                
                                <input type="radio" id="radio7" name="radios" value="true">
                                <label for="radio7"></label>
                
                            </div>
                        </div>
              </div>
              
              <div class="list-group-item list-group-item-accent-secondary text-left font-weight-bold text-muted text-uppercase small">
                <span>SIDEBAR COLOR OPTIONS</span>
                <!-- <div class="form-check" style="float: right;">
                    <input class="form-check-input" id="flexCheckDefault" type="checkbox">
                </div> -->
                <label class="switch-toggle">
                    <input id="sidebarsetting" type="checkbox">
                    <span class="slider"></span>
                </label>
              </div>
    
              <div class="list-group-item list-group-item-accent-secondary list-group-item-divider sidebar-color">
                  <div class="radio-check">
                      <div class="radio-toolbar">
                          <input type="radio" id="radio1" name="radios" value="all" checked>
                          <label for="radio1"></label>
                        
                          <input type="radio" id="radio2" name="radios" value="false">
                          <label for="radio2"></label>
                        
                          <input type="radio" id="radio3" name="radios" value="true">
                          <label for="radio3"></label>
    
                          <input type="radio" id="radio4" name="radios" value="true">
                          <label for="radio4"></label>
    
                          <input type="radio" id="radio5" name="radios" value="true">
                          <label for="radio5"></label>
    
                          <input type="radio" id="radio6" name="radios" value="true">
                          <label for="radio6"></label>
    
                          <input type="radio" id="radio7" name="radios" value="true">
                          <label for="radio7"></label>
    
                      </div>
                  </div>
              </div>
    
              <div class="list-group-item list-group-item-accent-secondary text-left font-weight-bold text-muted text-uppercase small">
                    <span>SIDEBAR BACKGROUND IMAGE</span>
                    <!-- <div class="form-check" style="float: right;">
                        <input class="form-check-input" id="flexCheckDefault" type="checkbox">
                    </div> -->
                    <label class="switch-toggle">
                        <input id="sidebgsetting" type="checkbox">
                        <span class="slider"></span>
                    </label>
              </div>
    
              <div class="list-group-item list-group-item-accent-secondary list-group-item-divider sidebar-image">
                    <div class="radio-check">
                        <div class="radio-toolbar">
                            <input type="radio" id="radio1" name="radios" value="all" checked>
                            <label for="radio1"></label>
                            
                            <input type="radio" id="radio2" name="radios" value="false">
                            <label for="radio2"></label>
                            
                            <input type="radio" id="radio3" name="radios" value="true">
                            <label for="radio3"></label>
            
                            <input type="radio" id="radio4" name="radios" value="true">
                            <label for="radio4"></label>
            
                            <input type="radio" id="radio5" name="radios" value="true">
                            <label for="radio5"></label>
            
                            <input type="radio" id="radio6" name="radios" value="true">
                            <label for="radio6"></label>
            
                            <input type="radio" id="radio7" name="radios" value="true">
                            <label for="radio7"></label>
            
                        </div>
                    </div>
              </div>
    
    
            </div>
          </div>
    </div>
</aside>